import ScriptForm from "./script-form";
function ScriptConfigurationContainer() {
  return <ScriptForm></ScriptForm>;
}

export default ScriptConfigurationContainer;
